import { useLayoutEffect } from 'react';
import { isTextEntry } from '../utils/textEntry';

const actions = 'button, a[href], [role="button"], [role="tab"], [role="option"], [role="menuitem"]';

export function preserveActionFocus(event) {
  if (event.defaultPrevented || event.button !== 0 || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey
    || !isTextEntry(document.activeElement)) return;
  const target = event.target?.closest?.(actions);
  if (!target || target.closest('[inert], [aria-disabled="true"]') || target.matches(':disabled')) return;
  // Text selection and native inputs (including ranges/checkboxes) retain
  // their own focus/drag behavior, even inside a composite action.
  if (event.target.closest('input, textarea, select') || isTextEntry(event.target)
    || target.isContentEditable) return;
  // A button's default mousedown blurs the editor BEFORE click. Mobile IME
  // dismissal can move/remove the target in that gap. Keep editing focus;
  // click still performs the original action, including intentional blur,
  // dialog focus, navigation or a user-activated file picker. Do not act on
  // pointerdown/touchstart: a cancelled press or scroll must do nothing.
  event.preventDefault();
}

export default function useActionFocus() {
  useLayoutEffect(() => {
    // Capture also covers portals and controls that stop propagation.
    document.addEventListener('mousedown', preserveActionFocus, true);
    return () => document.removeEventListener('mousedown', preserveActionFocus, true);
  }, []);
}
